// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map {
  height: 98%;
  width: 100%;
  overflow: visible;
}

ion-fab-button span {
  font-size: 10px !important;
  text-transform: Capitalized;
}

.custom-fab-button {
  width: 25px;
  height: 25px;
  --background: var(--ion-color-primary) !important;
}

ion-fab-list {
  margin: 21px -16px !important;
}
ion-fab-list ion-fab-button {
  width: 50px;
  height: 25px;
  --background: var(--ion-color-primary) !important;
  --color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/route-map/route-map.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;EACA,iBAAA;AACF;;AACA;EACE,0BAAA;EACA,2BAAA;AAEF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,iDAAA;AAGF;;AADA;EACE,6BAAA;AAIF;AAHE;EACE,WAAA;EACA,YAAA;EACA,iDAAA;EACA,2BAAA;AAKJ","sourcesContent":[".map {\n  height: 98%;\n  width: 100%;\n  overflow: visible;\n}\nion-fab-button span {\n  font-size: 10px !important;\n  text-transform: Capitalized;\n}\n.custom-fab-button {\n  width: 25px;\n  height: 25px;\n  --background: var(--ion-color-primary) !important;\n}\nion-fab-list {\n  margin: 21px -16px !important;\n  ion-fab-button {\n    width: 50px;\n    height: 25px;\n    --background: var(--ion-color-primary) !important;\n    --color: #ffffff !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
